import React, { FC, useEffect } from 'react';

import { Box } from '@mui/system';

import {
  AdminLegendVariant,
  IAdminRequestData,
  adminActions,
  isLoadingSelector,
  resetStatus,
} from '@pharmaplan/common';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { setFooterShow, setTitle } from '../../../actions/drawerActions';
import strings from '../../../localization';
import useAdminEvent from '../../../hooks/Admin/useAdminEvent';
import DrawerOutOfDateTitle from '../../common/DrawerOutOfDateTitle';

import SingleRequest from './SingleRequest';
import useMultiShiftFilter from '../../../hooks/useMultiShiftFilter';

interface IRequestList {
  date: string;
}

const RequestList: FC<IRequestList> = ({ date }) => {
  const dispatch = useAppDispatch();
  const successAction = adminActions.getAdminEvent;

  const { getAdminEventByDate } = useAdminEvent();

  const loading = useAppSelector((state) =>
    isLoadingSelector([successAction], state));
  const { adminEvents: requestList } = useMultiShiftFilter();

  useEffect(() => {
    const title = (
      <DrawerOutOfDateTitle
        date={date}
        dateLabel={strings.requestedWorkshiftsFormatted}
      />
    );

    dispatch(setTitle({ title }));
    dispatch(setFooterShow(false));
    getAdminEventByDate({
      type: AdminLegendVariant.requested,
      selectedDate: date.split('T')[0],
    });

    return () => {
      dispatch(resetStatus([adminActions.getAdminEvent]));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <Box>
      {loading ? (
        <SingleRequest
          successAction={adminActions.getAdminEvent}
          event={requestList?.[0] as IAdminRequestData}
        />
      ) : (
        (requestList as IAdminRequestData[]).map((item) =>
          (
            <SingleRequest
              successAction={adminActions.getAdminEvent}
              key={item.workshiftId}
              event={item}
            />
          ))
      )}
    </Box>
  );
};

export default RequestList;
